function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export default function getDisplayValue(value) {
  if (value && _typeof(value) === 'object') {
    if (Array.isArray(value)) {
      return value.map(function (singleOption) {
        return singleOption && singleOption.name;
      }).join(', ');
    }
    return value.name;
  }
  return '';
}